import React from 'react';

export default function ContentContainer({children}) {
  return <div className='content--conatiner'>
      {children}
  </div>;
}
